/* Stressless London — configurator v3 (Stressless Store België)
   Fork van cfg-berlin.js (Urban-collectie: rugleuning × onderstel × hoogte). Live render per klik van de officiële Stressless-beeldbank.
   Vereist: assets/cfg-mayfair-data.js (kleuren/groepen/CSS) en assets/cfg-london-data.js. */
(function () {
  var M = (window.CFGMAYFAIR || {}).D || {};
  var D = (window.CFGLONDON || {}).D || {};
  var CDN = M.CDN || "https://d3kpm8kazby4td.cloudfront.net/";
  if (!M.COVERS || !D.RUGS) return;
  var MODEL = D.MODEL || "London";

  /* ---------------------------------------------------------- data uitpakken */
  var COLS = M.COVERS.map(function (s) {
    var p = s.split("|");
    return {
      code: p[0], name: p[1], type: p[2], groep: p[3],
      colors: p[4].split(",").map(function (c) { var q = c.split(":"); return { c: q[0], n: q[1] }; })
    };
  });
  var COLBY = {}; COLS.forEach(function (c) { COLBY[c.code] = c; });
  var GRPLAB = {}; M.GROUPS.forEach(function (g) { GRPLAB[g[0]] = g[1]; });
  var BASE = {}; D.BASES.forEach(function (b) { BASE[b.k] = b; });
  var RUG = {}; D.RUGS.forEach(function (r) { RUG[r.k] = r; });
  function aluName(k) { return (D.ALU.filter(function (a) { return a[0] === k; })[0] || [])[1] || ""; }

  /* ---------------------------------------------------------- state */
  var S = { rug: "hoog", base: "sta", hoogte: "std", vtb: "ja", coll: "098", kleur: "90", alu: "45", frame: "front", mat: "leder" };

  function readHash() {
    var m = (location.hash || "").match(/cfg=([a-z0-9\-]+)/i); if (!m) return;
    var p = m[1].split("-");
    if (RUG[p[0]]) S.rug = p[0];
    if (BASE[p[1]]) S.base = p[1];
    if (p[2] === "std" || p[2] === "hoog") S.hoogte = p[2];
    if (p[3] === "ja" || p[3] === "nee") S.vtb = p[3];
    if (p[4] && COLBY[p[4].slice(0, 3)]) { S.coll = p[4].slice(0, 3); S.kleur = p[4].slice(3); }
    if (p[5] === "45" || p[5] === "40") S.alu = p[5];
    normalise();
  }
  var touched = false;
  function hashVal() { return [S.rug, S.base, S.hoogte, S.vtb, S.coll + S.kleur, S.alu].join("-"); }
  function writeHash() {
    if (!touched) return;
    try { history.replaceState(null, "", location.pathname + location.search + "#cfg=" + hashVal()); } catch (e) { }
  }

  function normalise() {
    var b = BASE[S.base];
    if (!b.vtb) S.vtb = "nee";
    if (!b.hoogte) S.hoogte = "std";
    var col = COLBY[S.coll];
    if (!col.colors.some(function (c) { return c.c === S.kleur; })) S.kleur = col.colors[0].c;
    S.mat = col.type;
    if (S.frame !== "front" && S.frame !== "01" && S.frame !== "02" && S.frame !== "03") S.frame = "front";
  }

  /* ---------------------------------------------------------- beeld */
  function pid(o) {
    o = o || {};
    var rug = RUG[o.rug || S.rug], bk = o.base || S.base, b = BASE[bk];
    return rug.art[bk] + (o.coll || S.coll) + (o.kleur || S.kleur) + (b.alu ? (o.alu || S.alu) : "");
  }
  function shot(size, frame, o) { return CDN + pid(o) + "_" + size + "_" + (frame || "front") + ".jpg"; }
  var CROPS = D.CROPS || { front: "x", "01": { s: "right", k: 0.66 }, "02": null, "03": "x" };
  var FRAMES = ["front", "01", "02", "03"];
  function noStool(o) {
    o = o || {};
    var rug = RUG[o.rug || S.rug], bk = o.base || S.base;
    return !!(rug.stoolInShot && BASE[bk].vtb && (o.vtb || S.vtb) === "nee");
  }
  function frames(o) { return noStool(o) ? FRAMES.filter(function (f) { return CROPS[f] !== "x"; }) : FRAMES; }
  function mainFrame(o) { return frames(o)[0]; }
  function cropFor(frame, o) {
    if (!noStool(o)) return null;
    var c = CROPS[frame || "front"];
    return c && c !== "x" ? c : null;
  }
  function cropStr(c) { return c ? c.s + ":" + c.k : ""; }
  function shotHTML(url, crop, alt) {
    var inner = "", img = "";
    if (crop) {
      inner = ' style="width:' + (crop.k * 100) + '%"';
      img = ' style="width:' + (100 / crop.k) + '%;margin-left:' + (crop.s === "left" ? "0" : "-" + (100 / crop.k - 100) + "%") + '"';
    }
    return '<span class="c3-shot"><span class="c3-in"' + inner + '><img loading="lazy" alt="' + (alt || "") + '" src="' + url + '"' + img + '></span></span>';
  }
  function setShot(el, url, frame) {
    var c = cropFor(frame);
    var inner = el.querySelector(".c3-in"), img = el.querySelector("img");
    if (c) {
      inner.style.width = (c.k * 100) + "%";
      img.style.width = (100 / c.k) + "%";
      img.style.marginLeft = c.s === "left" ? "0" : ("-" + (100 / c.k - 100) + "%");
    } else {
      inner.style.width = "100%"; img.style.width = "100%"; img.style.marginLeft = "0";
    }
    if (img.getAttribute("src") !== url) {
      var pre = new Image();
      el.classList.add("busy");
      pre.onload = function () { img.src = url; el.classList.remove("busy"); };
      pre.onerror = function () { img.src = url; el.classList.remove("busy"); };
      pre.src = url;
    }
  }

  /* ---------------------------------------------------------- prijs */
  function grp() { return COLBY[S.coll].groep; }
  function rowFor(vtb) { var t = D.P[S.base]; if (!t) return null; return t[BASE[S.base].vtb ? vtb : "nee"]; }
  function prijs() { var row = rowFor(S.vtb); return row ? (row[grp()] || null) : null; }
  function eur(n) { return "€ " + Number(n).toLocaleString("nl-BE"); }
  function vanafGroep(g) { var row = rowFor(S.vtb); return row && row[g] ? row[g][0] : null; }
  function vtbMeerprijs() {
    var t = D.P[S.base]; if (!t || !t.ja) return null;
    var g = grp(); return t.ja[g][0] - t.nee[g][0];
  }
  function pct(pr) { return Math.round((1 - pr[0] / pr[1]) * 100); }

  /* ---------------------------------------------------------- UI */
  var el = {};

  function media() {
    if (frames().indexOf(S.frame) < 0) S.frame = mainFrame();
    var big = shot("2400x2400", S.frame);
    setShot(el.stage, big.replace("2400x2400", "515x515"), S.frame);
    el.stage.querySelector("img").alt = "Stressless " + MODEL + " — " + samenvatting();
    var t = "";
    frames().forEach(function (f) {
      t += '<button class="c3-th' + (f === S.frame ? " on" : "") + '" data-frame="' + f + '" aria-label="Aanzicht ' + f + '">' +
        '<span class="c3-shot"><span class="c3-in"><img loading="lazy" alt=""></span></span></button>';
    });
    el.thumbs.innerHTML = t;
    el.thumbs.style.gridTemplateColumns = "repeat(" + Math.max(frames().length, 4) + ",1fr)";
    el.thumbs.querySelectorAll("[data-frame]").forEach(function (b) {
      var f = b.getAttribute("data-frame");
      setShot(b.querySelector(".c3-shot"), shot("300x300", f), f);
      b.onclick = function () { S.frame = f; media(); };
    });
    var cap = [];
    if (RUG[S.rug].stoolInShot === 0 && S.vtb === "ja" && BASE[S.base].vtb) cap.push("De voetenbank wordt bij de lage rug niet mee afgebeeld, maar zit wel in je bestelling.");
    if (S.hoogte === "hoog") cap.push("Afgebeeld op de standaardhoogte — jouw hoge base zet de zetel 4 cm hoger.");
    el.cap.textContent = cap.join(" ");
  }

  function panel() {
    var b = BASE[S.base], rug = RUG[S.rug], col = COLBY[S.coll], out = "", n = 1;
    var kleurNaam = (col.colors.filter(function (c) { return c.c === S.kleur; })[0] || {}).n || "";

    /* 1 — rugleuning */
    out += '<div class="c3-step"><div class="c3-lab"><span class="c3-no">' + (n++) + '</span> Rugleuning<em>' + rug.kort + '</em></div><div class="c3-opts c3-bases">';
    D.RUGS.forEach(function (r) {
      var o = { rug: r.k };
      out += '<button class="c3-card' + (r.k === S.rug ? " on" : "") + '" data-rug="' + r.k + '">' +
        shotHTML(shot("300x300", mainFrame(o), o), cropFor(mainFrame(o), o), "Stressless " + MODEL + " " + r.label) +
        '<b>' + r.kort + '</b></button>';
    });
    out += '</div><p class="c3-note">' + rug.note + '</p></div>';

    /* 2 — onderstel */
    out += '<div class="c3-step"><div class="c3-lab"><span class="c3-no">' + (n++) + '</span> Onderstel<em>' + b.label + '</em></div><div class="c3-opts c3-bases">';
    D.BASES.forEach(function (o) {
      var oo = { base: o.k };
      out += '<button class="c3-card' + (o.k === S.base ? " on" : "") + '" data-base="' + o.k + '">' +
        shotHTML(shot("300x300", mainFrame(oo), oo), cropFor(mainFrame(oo), oo), "Stressless " + MODEL + " " + o.label) +
        '<b>' + o.label + '</b></button>';
    });
    out += '</div><p class="c3-note">' + b.note + '</p>';
    var dm = (D.DIM[S.rug] || {})[b.k === "off" ? "off" : "sc"];
    if (dm) {
      var hh = S.hoogte === "hoog" && b.hoogte;
      var plus = function (v) { if (!hh) return v; return typeof v === "number" ? v + 4 : String(v).replace(/\d+/g, function (x) { return +x + 4; }); };
      out += '<p class="c3-note">Breedte ' + dm[0] + ' cm · diepte ' + dm[1] + ' cm · hoogte ' + plus(dm[2]) + ' cm · zithoogte ' + plus(dm[3]) + ' cm' +
        (dm[4] !== "—" ? ' · zitdiepte ' + dm[4] + ' cm' : '') + (b.vtb && S.vtb === "ja" ? " · " + D.VTBDIM : "") + '</p>';
    }
    out += '</div>';

    /* 3 — zithoogte */
    if (b.hoogte) {
      out += '<div class="c3-step"><div class="c3-lab"><span class="c3-no">' + (n++) + '</span> Hoogte van het onderstel<em>' +
        (S.hoogte === "hoog" ? "Hoge base" : "Standaard") + '</em></div><div class="c3-opts">' +
        '<button class="c3-chip' + (S.hoogte === "std" ? " on" : "") + '" data-hoogte="std"><span>Standaard</span></button>' +
        '<button class="c3-chip' + (S.hoogte === "hoog" ? " on" : "") + '" data-hoogte="hoog"><span>Hoge base <i>+ 4 cm</i></span></button>' +
        '</div><p class="c3-note">De hoge base zet de zitting ongeveer 4 cm hoger — dat maakt opstaan makkelijker. Zelfde prijs.</p></div>';
    }

    /* 4 — voetenbank */
    if (b.vtb) {
      var mp = vtbMeerprijs();
      out += '<div class="c3-step"><div class="c3-lab"><span class="c3-no">' + (n++) + '</span> Voetenbank<em>' +
        (S.vtb === "ja" ? "Met voetenbank" : "Zonder") + '</em></div><div class="c3-opts">' +
        '<button class="c3-chip' + (S.vtb === "ja" ? " on" : "") + '" data-vtb="ja"><span>Met voetenbank' + (mp ? ' <i>+ ' + eur(mp) + '</i>' : '') + '</span></button>' +
        '<button class="c3-chip' + (S.vtb === "nee" ? " on" : "") + '" data-vtb="nee"><span>Zonder voetenbank</span></button>' +
        '</div></div>';
    }

    /* 5 — bekleding */
    out += '<div class="c3-step"><div class="c3-lab"><span class="c3-no">' + (n++) + '</span> Bekleding &amp; kleur<em>' + col.name + ' ' + kleurNaam + '</em></div>';
    out += '<div class="c3-tabs">' +
      '<button class="c3-tab' + (S.mat === "leder" ? " on" : "") + '" data-mat="leder"><img src="' + CDN + 'leather.svg" alt="">Leder</button>' +
      '<button class="c3-tab' + (S.mat === "stof" ? " on" : "") + '" data-mat="stof"><img src="' + CDN + 'fabric.svg" alt="">Stof</button></div>';
    out += '<div class="c3-colls">';
    COLS.filter(function (c) { return c.type === S.mat; }).forEach(function (c) {
      var v = vanafGroep(c.groep);
      out += '<button class="c3-pill' + (c.code === S.coll ? " on" : "") + '" data-coll="' + c.code + '"><b>' + c.name + '</b><span>' +
        (v ? "vanaf " + eur(v) : "op aanvraag") + '</span></button>';
    });
    out += '</div><div class="c3-sw">';
    col.colors.forEach(function (c) {
      out += '<button class="c3-swb' + (c.c === S.kleur ? " on" : "") + '" data-kleur="' + c.c + '" title="' + col.name + ' ' + c.n + '">' +
        '<img loading="lazy" src="' + CDN + col.code + '_' + c.c + '_50.jpg" alt="' + col.name + ' ' + c.n + '"></button>';
    });
    out += '</div><div class="c3-sel" id="c3sel"><img src="' + CDN + col.code + '_' + S.kleur + '_200.jpg" alt="">' +
      '<div><b>' + col.name + ' ' + kleurNaam + '</b><span>' + GRPLAB[col.groep] + ' · klik voor een grote weergave</span></div></div></div>';

    /* 6 — pootkleur */
    if (b.alu) {
      out += '<div class="c3-step"><div class="c3-lab"><span class="c3-no">' + (n++) + '</span> Kleur van het onderstel<em>' + aluName(S.alu) + '</em></div><div class="c3-opts">';
      D.ALU.forEach(function (a) {
        out += '<button class="c3-chip' + (a[0] === S.alu ? " on" : "") + '" data-alu="' + a[0] + '"><img src="' + CDN + 'C_ALU_COLOR_' + a[0] + '_50.jpg" alt=""><span>' + a[1] + '</span></button>';
      });
      out += '</div></div>';
    }

    el.panel.innerHTML = out;
    bindPanel();
    priceBlocks();
  }

  function samenvatting() {
    var b = BASE[S.base], col = COLBY[S.coll];
    var kn = (col.colors.filter(function (c) { return c.c === S.kleur; })[0] || {}).n || "";
    var l = [MODEL + " " + RUG[S.rug].label.toLowerCase(), "onderstel " + b.label];
    if (b.hoogte) l.push(S.hoogte === "hoog" ? "hoge base (+4 cm)" : "standaardhoogte");
    if (b.vtb) l.push(S.vtb === "ja" ? "met voetenbank" : "zonder voetenbank");
    l.push(col.name + " " + kn);
    l.push(b.alu ? aluName(S.alu).toLowerCase() : "chroom");
    return l.join(" · ");
  }

  function priceHTML(compact) {
    var pr = prijs();
    if (!pr) return '<div class="c3-price"><span class="c3-now">Prijs op aanvraag</span></div>';
    return '<div class="c3-price"><span class="c3-now">' + eur(pr[0]) + '</span>' +
      '<span class="c3-was">' + eur(pr[1]) + '</span><span class="c3-badge">−' + pct(pr) + '%</span>' +
      (compact ? '' : '<p class="c3-fine">Actieprijs Stressless Store · je bespaart ' + eur(pr[1] - pr[0]) +
        ' · incl. btw · gratis levering in België en Nederland · levertijd ± 8 weken</p>') + '</div>';
  }

  function priceBlocks() {
    var btn = prijs() ? "In winkelmand" : "Vraag je prijs";
    el.buy.innerHTML = priceHTML(false) +
      '<div class="c3-sum">' + samenvatting() + '</div>' +
      '<div class="c3-actions"><button class="sp-btn sp-btn-dark" id="c3add">' + btn + '</button>' +
      '<a class="sp-btn sp-btn-outline" href="#showroom">Liever eerst proefzitten</a></div>' +
      '<div class="c3-msg" id="c3msg"></div>';
    el.bar.innerHTML = '<div class="c3-barin"><div class="c3-barp">' + priceHTML(true) +
      '<span class="c3-barsum">' + samenvatting() + '</span></div>' +
      '<button class="sp-btn sp-btn-dark" id="c3add2">' + btn + '</button></div>';
    var a = document.getElementById("c3add"); if (a) a.onclick = addToCart;
    var a2 = document.getElementById("c3add2"); if (a2) a2.onclick = addToCart;
  }

  function bindPanel() {
    var p = el.panel;
    function on(attr, fn) { p.querySelectorAll("[" + attr + "]").forEach(function (x) { x.onclick = function () { fn(x.getAttribute(attr)); upd(true); }; }); }
    on("data-rug", function (v) { S.rug = v; });
    on("data-base", function (v) { S.base = v; });
    on("data-hoogte", function (v) { S.hoogte = v; });
    on("data-vtb", function (v) { S.vtb = v; });
    on("data-mat", function (v) { S.mat = v; var first = COLS.filter(function (c) { return c.type === v; })[0]; S.coll = first.code; S.kleur = first.colors[0].c; });
    on("data-coll", function (v) { S.coll = v; S.kleur = COLBY[v].colors[0].c; });
    on("data-kleur", function (v) { S.kleur = v; });
    on("data-alu", function (v) { S.alu = v; });
    var sel = document.getElementById("c3sel");
    if (sel) sel.onclick = function () {
      var col = COLBY[S.coll], kn = (col.colors.filter(function (c) { return c.c === S.kleur; })[0] || {}).n || "";
      openLB(CDN + col.code + "_" + S.kleur + "_200.jpg", col.name + " " + kn, true);
    };
  }

  /* ---------------------------------------------------------- lightbox */
  function openLB(src, cap, small) {
    el.lb.querySelector(".c3-lbimg").innerHTML = '<img src="' + src + '" alt="' + cap + '"' + (small ? ' style="max-width:420px"' : '') + '>';
    el.lb.querySelector(".c3-lbcap").textContent = cap;
    el.lb.classList.add("on");
  }

  /* ---------------------------------------------------------- winkelmand */
  function addToCart() {
    var b = BASE[S.base], rug = RUG[S.rug], col = COLBY[S.coll], pr = prijs();
    var kn = (col.colors.filter(function (c) { return c.c === S.kleur; })[0] || {}).n || "";
    var msg = document.getElementById("c3msg");
    var o1 = rug.label + " – " + b.label;
    var o2 = GRPLAB[col.groep];
    var o3 = (b.vtb && S.vtb === "ja") ? "Met voetenbank" : "Zonder voetenbank";
    var props = { "Kleur": col.name + " " + kn };
    if (b.hoogte) props["Hoogte onderstel"] = S.hoogte === "hoog" ? "Hoge base (+4 cm)" : "Standaard";
    props["Kleur van het onderstel"] = b.alu ? aluName(S.alu) : "Chroom";
    props["Let op"] = D.NOTE;
    props["_foto"] = shot("515x515", mainFrame());
    props["_crop"] = cropStr(cropFor(mainFrame()));
    props["_link"] = location.origin + location.pathname + "#cfg=" + hashVal();

    if (location.hostname.indexOf("stresslessstore") < 0) {
      if (msg) { msg.className = "c3-msg on"; msg.innerHTML = "<b>Preview</b> — op de live site komt dit in je winkelmand:<br>" + samenvatting() + "<br>" + (pr ? eur(pr[0]) : "") + " · variant <code>" + [o1, o2, o3].join(" / ") + "</code>"; }
      return;
    }
    var btns = [document.getElementById("c3add"), document.getElementById("c3add2")].filter(Boolean);
    btns.forEach(function (x) { x.disabled = true; x.textContent = "Bezig…"; });
    fetch("/products/" + D.HANDLE + ".js").then(function (r) { return r.json(); }).then(function (pd) {
      var v = pd.variants.filter(function (x) { return x.option1 === o1 && x.option2 === o2 && x.option3 === o3; })[0];
      if (!v) throw new Error("variant");
      return fetch("/cart/add.js", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1, properties: props }] })
      }).then(function (r) { if (!r.ok) throw new Error("cart"); location.href = "/cart"; });
    }).catch(function () {
      btns.forEach(function (x) { x.disabled = false; x.textContent = "In winkelmand"; });
      if (msg) { msg.className = "c3-msg on"; msg.innerHTML = 'Deze samenstelling kunnen we niet online afronden. <a href="#london-contact">Stuur ons je keuze door</a> of bel de winkel — we regelen het meteen voor je.'; }
    });
  }

  function upd(fromUser) {
    if (fromUser) touched = true;
    normalise();
    panel();
    media();
    writeHash();
  }

  /* ---------------------------------------------------------- init */
  function mount() {
    if (!/\/collections\/(london|stressless-london)(\/|$|\?|#)/.test(location.pathname + "/")) return null;
    var sec = document.getElementById("configurator");
    if (!sec) return null;
    if (!document.getElementById("c3css")) {
      var st = document.createElement("style");
      st.id = "c3css";
      st.textContent = (window.CFGLONDON || {}).CSS || "";
      document.head.appendChild(st);
    }
    sec.innerHTML =
      '<div class="wrap c3">' +
      '<p class="eyebrow center">Stel jouw London samen</p>' +
      '<h2 class="center" style="max-width:22ch">Zie meteen hoe jouw London eruitziet</h2>' +
      '<p class="measure center" style="margin-top:14px">Rugleuning, onderstel, hoogte, bekleding en kleur — bij elke keuze verandert de foto mee. ' +
      'Wat je hier ziet, is exact de zetel die we voor je bestellen.</p>' +
      '<div id="cfg3"></div>' +
      '<div class="c3-trust"><span>Gratis levering in België én Nederland</span>' +
      '<span>Levertijd ± 8 weken · op maat gemaakt in Noorwegen</span>' +
      '<span>Beste prijsgarantie — vind je exact hetzelfde elders goedkoper, dan verlagen wij onze prijs</span></div>' +
      '</div>';
    return document.getElementById("cfg3");
  }

  function init() {
    var root = mount();
    if (!root) return;
    root.innerHTML =
      '<div class="c3-grid">' +
      '<div class="c3-media"><div class="c3-stage c3-shot" id="c3stage"><span class="c3-in"><img alt="Stressless ' + MODEL + '"></span>' +
      '<button class="c3-zoom" id="c3zoom" aria-label="Vergroot">⤢</button></div>' +
      '<div class="c3-thumbs" id="c3thumbs"></div>' +
      '<p class="c3-note" id="c3cap"></p></div>' +
      '<div class="c3-right"><div class="c3-panel" id="c3panel"></div><div class="c3-buy" id="c3buy"></div></div>' +
      '</div>' +
      '<div class="c3-bar" id="c3bar"></div>' +
      '<div class="c3-lb" id="c3lb"><div class="c3-lbimg"></div><p class="c3-lbcap"></p></div>';
    el.stage = document.getElementById("c3stage");
    el.thumbs = document.getElementById("c3thumbs");
    el.panel = document.getElementById("c3panel");
    el.buy = document.getElementById("c3buy");
    el.bar = document.getElementById("c3bar");
    el.lb = document.getElementById("c3lb");
    el.cap = document.getElementById("c3cap");
    el.lb.onclick = function () { el.lb.classList.remove("on"); };
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") el.lb.classList.remove("on"); });
    document.getElementById("c3zoom").onclick = function (e) {
      e.stopPropagation();
      openLB(shot("2400x2400", S.frame), samenvatting());
    };
    readHash();
    upd();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();
